import { Badge, HStack, SystemStyleObject, Text } from '@chakra-ui/core';
import React, { forwardRef, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { QuestionnaireTemplateStore } from '../../../store/questionnaireTemplateModel';
import { formElementSchema } from '../../schemas/formElement.schema';

const BADGE_PROPS = {
  borderRadius: '24px',
  px: '8px',
  py: '4px',
  minH: '24px',
  size: 'lg',
} as const;

const TEXT_STYLES: SystemStyleObject = {
  textTransform: 'none',
  fontWeight: '400',
  fontSize: 'sm',
  lineHeight: '16px',
};

type Props = { elementId: string };

const QuestionTypeChipInner = forwardRef<HTMLDivElement, Props>(function QuestionTypeChipInner({ elementId }, ref) {
  const { t } = useTranslation('questionnaireTemplate');
  const type = QuestionnaireTemplateStore.useStoreState((state) => state.getElementValue(elementId, 'questionType'));

  const schema = useMemo(() => formElementSchema[type], [type]);

  if (!schema) return null;

  return (
    <Badge ref={ref} background={schema.colors.bg} {...BADGE_PROPS}>
      <HStack spacing="4px">
        <Text color={schema.colors.text} sx={TEXT_STYLES}>
          {t(`formBuilder.schema.${schema.chipLabel}`)}
        </Text>
        {/* {schema.withImage && <MdOutlineImage color={schema.colors.text} size="16px" aria-hidden="true" />} */}
      </HStack>
    </Badge>
  );
});

export const QuestionTypeChip = React.memo(QuestionTypeChipInner);
